import {useIntl} from 'react-intl'
import {catalogConfigs} from '../configs'

type Props = {
  slug: string
  onChange: (slug: string) => void
}

// Unified catalog admin: dropdown that switches which CatalogConfig drives the shared screen.
// The slug stays in the URL so deep links keep working; onChange is expected to push the route.
export const CatalogPicker = ({slug, onChange}: Props) => {
  const intl = useIntl()

  return (
    <div className='nb-catalog-picker d-flex flex-column mb-5'>
      <label
        htmlFor='nb-catalog-picker-select'
        className='form-label text-muted small mb-1'
      >
        {intl.formatMessage({id: 'CATALOG.PICKER.LABEL'})}
      </label>
      <select
        id='nb-catalog-picker-select'
        className='form-select w-auto'
        value={slug}
        onChange={(e) => onChange(e.target.value)}
      >
        {catalogConfigs.map((config) => (
          <option key={config.slug} value={config.slug}>
            {intl.formatMessage({id: config.titleId})}
          </option>
        ))}
      </select>
    </div>
  )
}
